// ─── action types ────────────────────────────────────────────────────────────
export const FETCH_NOTIFICATIONS_REQUEST = "NOTIFICATIONS/FETCH_NOTIFICATIONS_REQUEST";
export const FETCH_NOTIFICATIONS_SUCCESS = "NOTIFICATIONS/FETCH_NOTIFICATIONS_SUCCESS";
export const FETCH_NOTIFICATIONS_FAILURE = "NOTIFICATIONS/FETCH_NOTIFICATIONS_FAILURE";

export const FETCH_UNREAD_COUNT_REQUEST  = "NOTIFICATIONS/FETCH_UNREAD_COUNT_REQUEST";
export const FETCH_UNREAD_COUNT_SUCCESS  = "NOTIFICATIONS/FETCH_UNREAD_COUNT_SUCCESS";
export const FETCH_UNREAD_COUNT_FAILURE  = "NOTIFICATIONS/FETCH_UNREAD_COUNT_FAILURE";

export const MARK_ONE_READ_REQUEST  = "NOTIFICATIONS/MARK_ONE_READ_REQUEST";
export const MARK_ONE_READ_SUCCESS  = "NOTIFICATIONS/MARK_ONE_READ_SUCCESS";
export const MARK_ONE_READ_FAILURE  = "NOTIFICATIONS/MARK_ONE_READ_FAILURE";

export const MARK_ALL_READ_REQUEST  = "NOTIFICATIONS/MARK_ALL_READ_REQUEST";
export const MARK_ALL_READ_SUCCESS  = "NOTIFICATIONS/MARK_ALL_READ_SUCCESS";
export const MARK_ALL_READ_FAILURE  = "NOTIFICATIONS/MARK_ALL_READ_FAILURE";

export const ARCHIVE_NOTIFICATION_REQUEST  = "NOTIFICATIONS/ARCHIVE_NOTIFICATION_REQUEST";
export const ARCHIVE_NOTIFICATION_SUCCESS  = "NOTIFICATIONS/ARCHIVE_NOTIFICATION_SUCCESS";
export const ARCHIVE_NOTIFICATION_FAILURE  = "NOTIFICATIONS/ARCHIVE_NOTIFICATION_FAILURE";

export const SET_DRAWER_OPEN = "NOTIFICATIONS/SET_DRAWER_OPEN";
export const RESET           = "NOTIFICATIONS/RESET";
